import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'tangram-sso-login-button',
  templateUrl: './sso-login-button.component.html',
  styleUrls: ['./sso-login-button.component.scss']
})
export class SsoLoginButtonComponent {
  @Input() loading: boolean = false;
  @Output() universityLogin = new EventEmitter<void>();

  onClick() {
    if (!this.loading) {
      this.universityLogin.emit();
    }
  }
}
